import { Component, Input, OnInit } from '@angular/core';

import { FormlyFieldConfig } from '@ngx-formly/core';
import { IonFormLabelPosition } from '@ts/shared/util-ionic';

@Component({
  selector: 'ts-ion-form-field-label-ui',
  templateUrl: './ion-form-field-label-ui.component.html',
  styleUrls: ['./ion-form-field-label-ui.component.scss'],
  standalone: false,
})
export class IonFormFieldLabelUiComponent implements OnInit {
  @Input({ required: true }) props!: NonNullable<
    Required<FormlyFieldConfig>['props']
  >;
  labelPosition!: IonFormLabelPosition;
  labelPositionDefault = 'stacked';

  ngOnInit() {
    this.labelPosition =
      this.props['labelPosition'] || this.labelPositionDefault;
  }
}
